function stableModulo(id: string, modulus: number) {
  let h = 0;
  for (let i = 0; i < id.length; i++) {
    h = (Math.imul(31, h) + id.charCodeAt(i)) | 0;
  }
  return Math.abs(h) % modulus;
}

const MATTER_LABEL_CHIP_STYLES = [
  "border-violet-200 bg-violet-50 text-violet-800 dark:border-violet-400/30 dark:bg-violet-500/15 dark:text-violet-300",
  "border-sky-200 bg-sky-50 text-sky-800 dark:border-sky-400/30 dark:bg-sky-500/15 dark:text-sky-300",
  "border-blue-200 bg-blue-50 text-blue-900 dark:border-blue-400/30 dark:bg-blue-500/15 dark:text-blue-300",
  "border-indigo-200 bg-indigo-50 text-indigo-900 dark:border-indigo-400/30 dark:bg-indigo-500/15 dark:text-indigo-300",
  "border-purple-200 bg-purple-50 text-purple-900 dark:border-purple-400/30 dark:bg-purple-500/15 dark:text-purple-300",
  "border-cyan-200 bg-cyan-50 text-cyan-900 dark:border-cyan-400/30 dark:bg-cyan-500/15 dark:text-cyan-300",
  "border-fuchsia-200 bg-fuchsia-50 text-fuchsia-900 dark:border-fuchsia-400/30 dark:bg-fuchsia-500/15 dark:text-fuchsia-300",
  "border-slate-200 bg-slate-50 text-slate-800 dark:border-slate-400/30 dark:bg-slate-400/15 dark:text-slate-300",
  "border-zinc-200 bg-zinc-50 text-zinc-800 dark:border-zinc-400/30 dark:bg-zinc-400/15 dark:text-zinc-300",
  "border-stone-200 bg-stone-50 text-stone-800 dark:border-stone-400/30 dark:bg-stone-400/15 dark:text-stone-300",
] as const;

/** Stable pastel chip colors for incident type, status, and similar firm-defined labels. */
export function matterLabelChipClassName(label: string) {
  const key = label.trim().toLowerCase();
  if (!key) {
    return "border-border bg-muted text-muted-foreground";
  }
  const idx = stableModulo(key, MATTER_LABEL_CHIP_STYLES.length);
  return MATTER_LABEL_CHIP_STYLES[idx];
}
